import request from '@/utils/request'

export function getAlarmTypeAll(query) {
  return request({
    url: '/shell/eqp/alarm/type/all',
    method: 'get',
    params: query
  })
}

// 通知公告列表
export function getNoticeList(query) {
  return request({
    url: '/notice/list',
    method: 'get',
    params: query
  })
}
// 通知公告详情
export function getNoticeDetail(id) {
  return request({
    url: '/notice/' + id,
    method: 'get'
  })
}
// 通知公告弹窗
export function lastNotice(query) {
  return request({
    url: '/notice/lastNotice/pc',
    method: 'get',
    params: query
  })
}
// 通知公告标记已读
export function setRead(noticeId) {
  return request({
    url: '/notice/setReaded/' + noticeId,
    method: 'put'
  })
}
// 告警信息列表
export function getAlarmNewsList(query) {
  return request({
    url: '/alarmNews/list',
    method: 'get',
    params: query
  })
}
// 报警信息单个已读
export function alarmRead(id) {
  return request({
    url: '/alarmNews/readed/' + id,
    method: 'put'
  })
}
// // 报警信息批量已读
export function batchRead(data) {
  return request({
    url: '/alarmNews/batchReaded',
    method: 'put',
    data
  })
}
// 报警信息面板数据
export function getAlarmNews() {
  return request({
    url: '/alarmNews/listTo100',
    method: 'get'
  })
}
// 报警信息面板数据全部已读
export function allReadNews() {
  return request({
    url: '/alarmNews/allReaded',
    method: 'get'
  })
}
// 获取未读报警信息数量
export function getUnReadCount() {
  return request({
    url: '/alarmNews/unreadedCount',
    method: 'get'
  })
}
// 用户登录报警或预警信息的弹框
export function alarmNewsAlert() {
  return request({
    url: '/alarmNews/unreadedAlertList',
    method: 'get'
  })
}
// 登录报警或预警信息弹框已读
export function delAlertAlarm(id) {
  return request({
    url: '/alarmNews/delAlertAlarm/' + id,
    method: 'delete'
  })
}
